import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export default function HolidayLeaveTable({ holidayLeaveCalculation }) {
  const { t } = useTranslation(['menus', 'forms', 'messages']);

  const {
    holidayDaysYear,
    numberOfHolidayDaysContract,
    numberOfHolidayDays,
    numberOfHolidayDaysPast,
    numberOfHolidayDaysByEndOfContract,
    numberOfHolidayDaysUsed,
    currentlyAvailableHolidayDays,
  } = holidayLeaveCalculation;

  return (
    <div className="rounded-md border bg-white p-4">
      <div className="divide-y [&>div]:flex [&>div]:justify-between [&>div]:py-2">
        <div>
          <p className="text-accent">
            <strong>{t('holidayDaysForYear', { ns: 'messages' })}:</strong>
          </p>
          <strong>{holidayDaysYear}</strong>
        </div>

        <div>
          <p>{t('numberOfHolidayDaysPast', { ns: 'messages' })}:</p>
          <strong>{numberOfHolidayDaysPast}</strong>
        </div>

        <div>
          <p>{t('numberOfHolidayDaysUsedYear', { ns: 'messages' })}:</p>
          <strong>{numberOfHolidayDaysUsed}</strong>
        </div>

        <div>
          <p>{t('numberOfHolidayDaysContract', { ns: 'messages' })}:</p>
          <strong>{numberOfHolidayDaysContract}</strong>
        </div>

        {!numberOfHolidayDaysByEndOfContract && (
          <div>
            <p className="text-primary">
              {t('totalHolidayDaysLeftYearEnd', { ns: 'messages' })}:
            </p>
            <strong className="text-primary">{numberOfHolidayDays}</strong>
          </div>
        )}

        {numberOfHolidayDaysByEndOfContract && (
          <div>
            <p className="text-primary">
              {t('totalDaysLeftLimitedContract', { ns: 'messages' })}:
            </p>
            <strong className="text-primary">
              {numberOfHolidayDaysByEndOfContract}
            </strong>
          </div>
        )}

        <div>
          <Tooltip
            placement="topLeft"
            title={t('currentlyAvailableHolidayDaysInfo', {
              ns: 'messages',
            })}
          >
            <p>
              <InfoCircleOutlined className="mr-1 text-base text-zinc-400" />

              <strong>
                {t('currentlyAvailableHolidayDays', { ns: 'messages' })}:
              </strong>
            </p>
          </Tooltip>

          <strong
            className={
              currentlyAvailableHolidayDays < 0 ? 'text-danger' : 'text-primary'
            }
          >
            {currentlyAvailableHolidayDays}
          </strong>
        </div>
      </div>
    </div>
  );
}
